import { Link } from "react-router-dom"
import "../assets/css/error.css"
 
export default function Error404() {
    return(
        <div id="main-site">
            <div className="fof">
                <h1>Error 404</h1>
                <p>صفحه مورد نظر پیدا نشد!</p>
                <Link to="/" className="btn btn-primary">بازگشت به صفحه اصلی</Link>
            </div>
        </div>
    )
}